import CookieManager from '@react-native-cookies/cookies';
import { Platform } from 'react-native';

export const useCheckForSessionCookies = () => {
  const checkForSessionCookies = async (): Promise<string | null> => {
    try {
      let cookies = await CookieManager.get('https://staging.boyens-api.de', true);
      if (Platform.OS === 'ios') {
        cookies = await CookieManager.getAll(true);
      }
      //console.log("Cookies: ", JSON.stringify(cookies, null, 2));
      let newToken = null;
      if (cookies.fe_typo_user) {
        newToken = cookies.fe_typo_user.value;
        return newToken;
      } else {
        //console.log("fe_typo_user cookie not found.");
        return null;
      }
    } catch (error) {
      console.error("Error checking for session cookie:", error);
      return null;
    }
  }
  return { checkForSessionCookies }

};
